module.exports = __webpack_public_path__ + "static/segmentation@3x.c97a95aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/segmentation@3x.png
// module id = 680
// module chunks = 193162123475590